import Coupons from './Coupons'
export default Coupons
